import { type ReactNode } from 'react'

import cn from 'classnames'

import Separator from 'modules/core/components/Separator'

import './index.styles.css'
type Types = 'brand' | 'primary' | 'negative'
interface Props {
  compact?: boolean
  color?: string
  subtitle?: string
  label?: ReactNode
  type?: Types
  separator?: boolean
  centered?: boolean
}

const Title = ({ compact, color, centered, label, subtitle, separator, type }: Props) => {
  const titleClassName = compact ? 'Title_titleCompact' : 'Title_title'
  const titleTypeClass =
    type === 'brand'
      ? 'Title_titleBrand'
      : type === 'primary'
        ? 'Title_titlePrimary'
        : type === 'negative'
          ? 'Title_titleNegative'
          : 'Title_titleBrand'

  const subtitleTypeClass =
    type === 'brand'
      ? 'Title_subtitleBrand'
      : type === 'primary'
        ? 'Title_subtitlePrimary'
        : type === 'negative'
          ? 'Title_subtitleNegative'
          : 'Title_subtitleBrand'

  const separatorClass = compact ? 'Title_separatorCompact' : 'Title_separator'

  return (
    <div className={cn('Title_root', centered && 'Title_centered')}>
      {!!subtitle && <h3 className={cn('Title_subtitle', subtitleTypeClass)}>{subtitle}</h3>}
      <h2 className={cn(titleClassName, titleTypeClass)}>{label}</h2>
      {separator && (
        <div className={separatorClass}>
          <Separator color={color} type={type || 'brand'} />
        </div>
      )}
    </div>
  )
}

export default Title
